import { Attrs, MinzeElement } from 'minze'

export interface LvcSimpleArrowRightIcon {
  dataColor?: string
}

export class LvcSimpleArrowRightIcon extends MinzeElement {
  attrs: Attrs = [['data-color'], ['width', '28'], ['height', '28']]

  static observedAttributes = ['width', 'height']

  onAttributeChange(
    name?: string | undefined,
    oldValue?: string | null | undefined,
    newValue?: string | null | undefined
  ): void | Promise<void> {
    if (name === 'width' && newValue) {
      this.width = Number(newValue)
    }
    if (name === 'height' && newValue) {
      this.height = Number(newValue)
    }
  }

  html = () => `
    <svg width="${this.width}" height="${this.height}" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0117 18.9787C13.1261 17.9114 15.2097 15.8074 16.3021 14.6997C16.6932 14.3031 16.6829 13.6638 16.2953 13.2638C14.9959 11.9231 13.7023 10.3908 12.0117 9" stroke="white" stroke-width="1.35" stroke-linecap="round"/>
</svg>
  `

  css = () => `
  :host {
    width: ${this.width};
    height: ${this.height};
    display: flex;
  }
  `
}
